const routePermissionConfig = {
  "route-management": ["bkash-super-user", "territory_manager", "agency_user"],
};
export default function _checkRouteAvailibility(route) {
  return routePermissionConfig[route].includes(
    JSON.parse(localStorage.getItem("currUserType"))
  );
}
